import * as React from "react";
import Dialog from "../dialog";
import VerifyComponent from "./index";
import ProviderComponent from "../provider";
import { action } from "pc@action/index";
let dialogContainer: any;

const verifyDialog = () => {
  dialogContainer = new Dialog({
    title: "请输入信息",
    content: (
      <ProviderComponent>
        <VerifyComponent />
      </ProviderComponent>
    ),
    footer: true,
    wrapClassName: "verifyDialog",
    onOK: () => {
      action.onSubmitInfo(dialogContainer);
    }
  });
  console.log(dialogContainer);
};

export default {
  verify() {
    return verifyDialog();
  }
};



// WEBPACK FOOTER //
// ./src/pc/component/verify/verify.tsx